import React from "react";

import "./styles.css";
import Clock from "./Clock";

export default function SimpleCard() {
	return <Clock />;
}
